import React, { useContext, useEffect, useState } from "react";
import "./_style.scss";
import { Box, Collapse } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import authorityUserType from "../../../assets/data/TkAuthorityProperty";
import { useNavigate } from "react-router-dom";
import { BusinessContext } from "../../../context/businessContext";
import { GlobalContext } from "../../../context/globalContext";

/**
 * サイドバー部品
 * TkSideBarコンポーネントは、サイドバーを表示する部品です。
 * @param {userType} props - ユーザータイプ
 * @param {getWidth} props - サイドバーの幅を取得するコールバック関数
 * @param {data} props - サイドバーの表示する項目
 * @return TkSideBar サイドバー部品
 */
const TkSideBar: React.FC<any> = (props) => {
  const { userType, getWidth, data } = props;

  const { setState: setBussinessState } = useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);

  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [sidebarWidth, setSidebarWidth] = useState<number>(330);
  const [sideBarMenuData, setSideBarMenuData] = useState(data);

  const handleClick = () => {
    if (open) {
      setSidebarWidth(75);
      getWidth(75);
    } else {
      setSidebarWidth(330);
      getWidth(330);
    }
    setOpen(!open);
  };

  useEffect(() => {
    setSideBarMenuData(data);
  }, [data]);

  useEffect(() => {
    handleClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType]);

  const handleClickToJump = (url: string, job: any) => {
    setBussinessState({
      common: {
        businessType: job ?? "",
      },
    });
    setState({
      ...state,
      errorMsgId: "",
    });
    navigate(url);
  };

  const titleWidth = sidebarWidth - 1;

  return userType === authorityUserType.userTypeNumber.KIKO &&
    sideBarMenuData !== null &&
    sideBarMenuData !== undefined ? (
    <>
      <Box className="tkSideBar" data-testid="tkSideBarForTest">
        <Sidebar
          className="tkSideBarMain"
          style={{
            width: sidebarWidth,
          }}
        >
          <Menu>
            <MenuItem
              data-testid="tkSideBarMenuForTest"
              icon={<MenuIcon />}
              onClick={() => {
                handleClick();
              }}
              className="menuTop"
              style={{ width: titleWidth, transition: "width 0.3s" }}
            >
              退職共済システム
            </MenuItem>
            <Box className="menuBox">
              {sideBarMenuData.map((menu: any, key: any) => (
                <Box key={key}>
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <MenuItem
                      className="menuTitle"
                      icon={menu.icon}
                      rootStyles={{ background: "#f7fafc" }}
                      onClick={() => handleClickToJump(menu.url, menu)}
                    >
                      {menu.label}
                    </MenuItem>
                  </Collapse>
                  {menu.children?.map((submenu: any, index: any) => (
                    <MenuItem
                      className={`menuContent`}
                      key={index}
                      rootStyles={{
                        background:
                          submenu.url === window.location.pathname
                            ? "#03af7a"
                            : "#bfe9db",
                        color:
                          submenu.url === window.location.pathname
                            ? "#fff"
                            : "#333",
                        marginTop: "2px",
                      }}
                      onClick={() =>
                        handleClickToJump(submenu.url, submenu.bussinessType)
                      }
                    >
                      {submenu.label}
                    </MenuItem>
                  ))}
                </Box>
              ))}
            </Box>
          </Menu>
        </Sidebar>
      </Box>
    </>
  ) : (
    <></>
  );
};

export default TkSideBar;
